/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomersService } from '@app/customers/services/customers.service';
import * as  CustomersActions from '@app/customers/store/customers.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class CustomersEffects {
  constructor(
    private actions$: Actions<CustomersActions.CustomersActions>,
    private customersService: CustomersService,
    private translateService: TranslateService,
    private snackBarService: MatSnackBar
  ) { }

  
  loadCustomers$ = createEffect(() => this.actions$.pipe(
    ofType(CustomersActions.LOAD_CUSTOMERS),
    switchMap(() => this.customersService.getCustomers().pipe(
      map(customers => new CustomersActions.LoadCustomersSuccess(customers)),
      catchError(() => of(new CustomersActions.LoadCustomersFailure()))
    ))
  ));

  
  loadPartialCustomers$ = createEffect(() => this.actions$.pipe(
    ofType(CustomersActions.LOAD_CUSTOMERS_PARTIAL),
    switchMap(action => this.customersService.getCustomersStartWith(action.searchString).pipe(
      map(customers => new CustomersActions.LoadCustomersPartialSuccess(customers)),
      catchError(() => of(new CustomersActions.LoadCustomersPartialFailure()))
    ))
  ));

  
  loadCustomersFailure$ = createEffect(() => this.actions$.pipe(
    ofType(CustomersActions.LOAD_CUSTOMERS_FAILURE, CustomersActions.LOAD_CUSTOMERS_PARTIAL_FAILURE),
    switchMap(() => this.translateService.get('customer.errors.load').pipe(
      tap(errorMessage => this.snackBarService.open(errorMessage))
    ))
  ), { dispatch: false });
}
